






































































import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import moment from "moment";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseByExternalIdRequest,
  HsabExpenseCategory,
  HsabExpenseOriginator,
  HsabExpenseResponse,
  HsabTransactionDetail,
  ManagedExpenseResponse,
  ManagedExpenseType,
} from "@/shared/types";
import { wexClaimReceiptStatusIcon } from "@/shared/awesomeIconMapper";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import HsabTransactionChildRow from "@/shared/components/cash/hsabank/HsabTransactionChildRow.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useNotifierStore } from "@/shared/store/notifier";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabHsaAccountTransactionStore } from "@/employee/store/hsabHsaAccountTransaction";
import DebitCardTransactionModal from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";

@Component({
  components: {
    DebitCardTransactionModal,
    GenericLoadingSpinner,
    HsabTransactionChildRow,
    Pill,
    CurrencyAmount,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
  }
})
export default class HsabTransactionListItem extends Vue {
  hsabExpenseStore = useHsabExpenseStore();
  notifierStore = useNotifierStore();
  custodianSettingsStore = useCustodianSettingsStore();
  hsabHsaAccountTransactionStore = useHsabHsaAccountTransactionStore();
  wexClaimReceiptStatusIcon = wexClaimReceiptStatusIcon;
  CombinedClaimReceiptStatusMap = CombinedClaimReceiptStatusMap;
  flagStore = useFeatureFlagStore();

  @Prop()
  transaction: HsabTransactionDetail;

  @Prop()
  isNotional: boolean;

  @Prop()
  isLoadingExpenseCheck: boolean;

  isOpen = false;
  expense: HsabExpenseResponse = null;
  managedExpense: ManagedExpenseResponse = null;
  showDetailsModal = false;
  showEditModal = false;
  showDebitCardModal = false;
  thinking = false;

  toggleOpen (): void {
    this.isOpen = !this.isOpen;
  }

  get getPillType (): string {
    if (this.transaction.creditDebitIndicator === "C") {
      return "green-bg";
    }
    return "red-bg";
  }

  get showStatusPill () {
    return !this.transaction.isPosted;
  }

  get formattedDate (): string {
    const date = this.transaction.isPosted ? this.transaction.postingDate : this.transaction.effectiveDate;
    return moment(date).format("MMM D, YYYY");
  }

  get isCredit () {
    return this.transaction.creditDebitIndicator === "C";
  }

  get isDebit () {
    return this.transaction.creditDebitIndicator === "D";
  }

  get currencyClasses () {
    let result = "text-center pr-0 w-100 font-size-corection";
    if (this.transaction.creditDebitIndicator === "NA") {
      result = "text-center pr-0 w-100 font-size-corection color-grey";
    } else if (this.isDebit) {
      result = "text-center pr-0 w-100 font-size-corection color-red";
    }
    return [result];
  }
  get showViewExpenseButton () {
    return this.flagStore.flags.bend19778ViewExpenseButtonInTransactions
        && !this.isLoadingExpenseCheck
        && !this.thinking
        && ((this.hasFlowId && this.hsabHsaAccountTransactionStore.doesFlowIdHaveAssociation(this.transaction.flowId))
            || this.hasClaimNumber);
  }
  get hasFlowId () {
    return this.transaction && this.transaction.flowId;
  }
  get hasClaimNumber () {
    return this.transaction && this.transaction.claimNumber;
  }

  async onViewExpenseClicked () {
    if (this.isNotional) {
      await this.showExpenseModalForNotionalTransaction();
    } else {
      await this.showExpenseModalForHsaTransaction();
    }
  }

  async showExpenseModalForNotionalTransaction () {
    this.thinking = true;

    const request: HsabExpenseByExternalIdRequest = {
      externalReimbursementId: this.hasClaimNumber ? this.transaction.claimNumber : null,
      externalTransactionId: this.hasFlowId ? this.transaction.flowId : null,
    };
    this.expense = await this.hsabExpenseStore.loadExpenseByExternalId(request);
    this.thinking = false;
    if (!this.expense) {
      this.notifierStore.setDanger("This Expense was not found");
      return;
    }
    if (this.transaction.isPosted) {
      this.showDetailsModal = true;
    } else {
      this.showEditModal = true;
    }
  }

  async showExpenseModalForHsaTransaction () {
    const flowIdAssociations = this.hsabHsaAccountTransactionStore.getFlowIdAssociations(this.transaction.flowId);

    if (flowIdAssociations.hsabExpenseReimbursementId !== null) {
      // claim already exists, Show details modal
      this.thinking = true;
      this.expense = await this.hsabExpenseStore.loadExpenseById(flowIdAssociations.hsabExpenseId);
      this.showDetailsModal = true;
      this.thinking = false;
    } else if (flowIdAssociations.hsabExpenseId !== null) {
      // editing one created from debit card/disbursement, show debit card modal
      this.thinking = true;
      this.expense = await this.hsabExpenseStore.loadExpenseById(flowIdAssociations.hsabExpenseId);
      this.showEditModal = true;
      this.thinking = false;
    } else if (flowIdAssociations.reimbursementId !== null) {
      // creating from debit card/disbursement, show debit card modal
      const debitTransReimbursement = await this.hsabExpenseStore.loadDebitCardReimbursementById(flowIdAssociations.reimbursementId);
      this.managedExpense = {
        managedExpenseType: ManagedExpenseType.Transaction,
        displayText: this.transaction.description,
        expenseCategory: debitTransReimbursement.expenseCategory,
        reimbursementId: flowIdAssociations.reimbursementId,
        amount: -this.transaction.amount, // flip the sign do to money out of account showing as negative in ui
        dateOfService: this.transaction.paymentDate,
        planDisplayText: [""],
        status: [CombinedClaimReceiptStatus.None],
        showErrorIndicator: false,
        expenseId: null,
        originator: HsabExpenseOriginator.Unknown,
      };
      this.showDebitCardModal = true;
    }
  }

  onCloseEditEvent () {
    this.showEditModal = false;
  }

  onCloseDetailsEvent () {
    this.showDetailsModal = false;
  }

  oncloseDebitCardTransactionModal () {
    this.showDebitCardModal = false;
  }

  onEditSubmittedExpenseEvent () {
    this.showDetailsModal = false;
    this.showEditModal = true;
  }
}
